"use client";
import Link from 'next/link';

export default function HomePage() {
  return (
    <main className="min-h-screen bg-[#FAF9F6] text-black font-sans selection:bg-black selection:text-[#FAF9F6]">
      
      {/* 1. HERO SECTION */}
      {/* Note: Replaced background with a premium minimal architecture/desert luxury aesthetic */}
      <section className="relative flex flex-col items-center justify-center text-center px-6 min-h-[90vh] bg-[url('https://images.unsplash.com/photo-1584551246679-0daf3d275d0f?q=80&w=2000')] bg-cover bg-center bg-no-repeat overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#FAF9F6]"></div>
        
        <div className="relative z-10 max-w-5xl mx-auto mt-16 md:mt-0 animate-fade-in-up">
          <p className="text-white/80 uppercase tracking-[0.4em] text-xs font-bold mb-6">
            Heritage Tailors of Muscat
          </p>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white uppercase tracking-tighter mb-8 leading-[0.9]">
            The Art of the <br /> <span className="text-transparent border-text italic">Dishdasha</span>
          </h1>
          <p className="text-gray-200 text-lg md:text-xl mb-12 max-w-2xl mx-auto font-light leading-relaxed">
            Elevating traditional Arabian attire. Masterfully tailored Omani, Kuwaiti, and Saudi cuts crafted from the world's finest Japanese cottons and luxury blends.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              href="/measure" 
              className="w-full sm:w-auto bg-white text-black px-12 py-4 font-black uppercase tracking-widest text-xs hover:bg-gray-100 hover:scale-105 transition-all duration-300"
            >
              Book a Fitting
            </Link>
            <Link 
              href="/fabrics" 
              className="w-full sm:w-auto bg-transparent border border-white/50 text-white px-12 py-4 font-black uppercase tracking-widest text-xs hover:bg-white hover:text-black transition-all duration-300 backdrop-blur-sm"
            >
              Explore Fabrics
            </Link>
          </div>
        </div>
      </section>

      {/* 2. OUR COLLECTIONS (New Section for Product Variety) */}
      <section className="py-24 px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tighter mb-4">Signature Cuts</h2>
            <div className="w-16 h-1 bg-black mx-auto"></div>
            <p className="text-gray-500 mt-6 max-w-xl mx-auto text-sm">Precision tailoring honoring the distinct sartorial traditions of the Gulf.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Omani */}
            <div className="group relative aspect-[3/4] bg-gray-100 overflow-hidden">
              <img src="https://images.unsplash.com/photo-1626553835474-98c47b596da2?q=80&w=800" alt="Omani Dishdasha detail" className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-700 opacity-90" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
              <div className="absolute bottom-8 left-8 text-white">
                <h3 className="text-2xl font-black uppercase tracking-widest mb-2">Omani</h3>
                <p className="text-sm font-light text-white/80">Traditional tassel & intricate embroidery</p>
              </div>
            </div>
            {/* Kuwaiti / Saudi */}
            <div className="group relative aspect-[3/4] bg-gray-100 overflow-hidden">
              <img src="https://images.unsplash.com/photo-1596484552993-84f5bc9e9614?q=80&w=800" alt="Kuwaiti Collar detail" className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-700 opacity-90" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
              <div className="absolute bottom-8 left-8 text-white">
                <h3 className="text-2xl font-black uppercase tracking-widest mb-2">Kuwaiti & Saudi</h3>
                <p className="text-sm font-light text-white/80">Structured collars & refined cuffs</p>
              </div>
            </div>
            {/* Accessories */}
            <div className="group relative aspect-[3/4] bg-gray-100 overflow-hidden">
              <img src="https://images.unsplash.com/photo-1621364536287-7f97bcf9501a?q=80&w=800" alt="Omani Kumma" className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-700 opacity-90" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
              <div className="absolute bottom-8 left-8 text-white">
                <h3 className="text-2xl font-black uppercase tracking-widest mb-2">Accessories</h3>
                <p className="text-sm font-light text-white/80">Hand-stitched Kummas & Premium Muzzars</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. THE ALSHAKILEE PROCESS */}
      <section className="py-24 px-8 bg-[#FAF9F6] border-t border-gray-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tighter mb-4">The Experience</h2>
            <div className="w-16 h-1 bg-black mx-auto"></div>
          </div>
          
          <div className="grid md:grid-cols-3 gap-12 text-center">
            <div className="space-y-4">
              <span className="text-6xl font-black text-gray-200 italic">01</span>
              <h3 className="text-xl font-bold uppercase tracking-widest">Measure</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Provide your precise measurements online or visit our Muscat studio for an exact fitting.
              </p>
            </div>
            <div className="space-y-4">
              <span className="text-6xl font-black text-gray-200 italic">02</span>
              <h3 className="text-xl font-bold uppercase tracking-widest">Select</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Choose from our curated library of authentic Toyobo, Shikibo, and premium winter wools.
              </p>
            </div>
            <div className="space-y-4">
              <span className="text-6xl font-black text-gray-200 italic">03</span>
              <h3 className="text-xl font-bold uppercase tracking-widest">Craft</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Our artisans cut and stitch your garment with impeccable attention to collar, cuff, and tarboosh detail.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. HERITAGE & CRAFTSMANSHIP (Split Image/Text) */}
      <section className="flex flex-col md:flex-row min-h-[70vh]">
        <div className="md:w-1/2 bg-black text-white p-12 md:p-24 flex flex-col justify-center">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-[#D4AF37] mb-6">Our Heritage</p>
          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-8 leading-tight">
            Uncompromising <br/> Quality.
          </h2>
          <p className="text-gray-300 leading-relaxed mb-10 font-light">
            Every Alshakilee garment is a testament to Gulf heritage. We merge generations of traditional Omani hand-stitching techniques with modern precision to create Dishdashas that drape perfectly and endure the test of time.
          </p>
          <Link href="/about" className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest hover:text-[#D4AF37] transition-colors w-max group">
            Discover Our Story
            <span className="group-hover:translate-x-2 transition-transform">→</span>
          </Link>
        </div>
        <div className="md:w-1/2 min-h-[400px] bg-[url('https://images.unsplash.com/photo-1598300188481-9b936e6328bc?q=80&w=2000')] bg-cover bg-center">
          {/* Decorative image placeholder - ideally a close up of white fabric or stitching */}
        </div>
      </section>

      {/* 5. CALL TO ACTION / CTA */}
      <section className="py-32 px-6 text-center bg-white border-t border-gray-100">
        <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-6">Redefine your traditional wardrobe</h2>
        <p className="text-gray-500 mb-10 max-w-md mx-auto">Create your profile today and experience the luxury of garments made exclusively for you.</p>
        <Link 
          href="/measure" 
          className="bg-black text-white px-12 py-5 font-black uppercase tracking-[0.2em] text-sm hover:bg-gray-800 transition-colors"
        >
          Begin Your Journey
        </Link>
      </section>

    </main>
  );
}